import { inject, observer } from "mobx-react";
import React from "react";
import { NavigateFunction } from "react-router-dom";
import ServiceStore from "../ServiceStore";
import { UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import { PricingBuilder } from "../../../shared/components";

type Props = {
  serviceStore?: ServiceStore;
  navigate: NavigateFunction;
};

@inject("serviceStore")
@observer
class PricingPage extends React.Component<Props> {
  render(): React.ReactNode {
    const html = UtilityMethods.getEditorHtmlContent(
      this.props.serviceStore?.detailPage?.descriptionEditorRawContent || ""
    );
    return (
      <PricingBuilder
        showPricingOptions={true}
        headerCaption="Service Pricing"
        itemName={this.props.serviceStore?.detailPage?.name || ""}
        pricingPageData={this.props.serviceStore?.pricingPageData}
        hideTermPlusRecurrence={true}
        isServicePricingPage={true}
        detailPage={this.props.serviceStore?.detailPage}
        descriptionHtml={html}
      />
    );
  }
}

export default withRouter(PricingPage);
